import { render, staticRenderFns } from "./AddAdress.vue?vue&type=template&id=50d0bc01&scoped=true"
import script from "./AddAdress.vue?vue&type=script&lang=js"
export * from "./AddAdress.vue?vue&type=script&lang=js"
import style0 from "./AddAdress.vue?vue&type=style&index=0&id=50d0bc01&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d0bc01",
  null
  
)

export default component.exports